import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import classNames from 'classnames'
import { ReactNode, useEffect, useState } from 'react'
import { Collapse } from 'ui'

import style from './DropDownBlock.module.scss'

type TDropDownBlock = {
  title: string
  step?: string
  isDateExist?: boolean
  children: ReactNode
  description?: string | null
  isChildren?: boolean
  className?: string
  isOpen?: boolean
  testId?: string
}

// выпадающий блок заявки
export function DropDownBlock({
  title,
  step,
  children,
  className,
  isDateExist = true,
  description,
  isChildren = false,
  isOpen = false,
  testId,
}: TDropDownBlock) {
  const [isOpened, setOpened] = useState<boolean>(isOpen)
  const handleOpen = () => {
    setOpened(!isOpened)
  }

  useEffect(() => {
    setOpened(isOpen)
  }, [isOpen])

  return (
    <div
      className={classNames(style.dropDownBlock, className, {
        [style.dropDownChilder]: isChildren,
      })}
    >
      <div className={style.header} onClick={handleOpen}>
        <div className={style.leftParth}>
          <div className={style.titleWrap}>
            {step && <span className={classNames(style.step)}>{step}</span>}
            <span className={isChildren ? 'h4' : 'h2'}>{title}</span>
          </div>
          {description && (
            <span className={classNames(style.description, 'default-text')}>
              {description}
            </span>
          )}
        </div>

        {isDateExist && (
          <button
            type='button'
            className={classNames(style.dropDownBtn, {
              [style.dropDownBtnActive]: isOpened,
            })}
            onClick={handleOpen}
            data-testid={testId}
          >
            <ChevronRightIcon />
          </button>
        )}
      </div>

      <Collapse in={isOpened} className={style.collapse}>
        {children}
      </Collapse>
    </div>
  )
}
